module.exports = __webpack_public_path__ + "img/3c2f799.png";